<template>
  <div class="intervals">
    <Interval
      v-for="(interval, intervalIndex) in pickup.intervals"
      :key="intervalIndex"
      class="interval"
      remove-btn
      :interval="interval"
      @change="updateInterval({ index: intervalIndex, value: $event})"
      @remove="removeInterval(intervalIndex)"
    />
  </div>
</template>

<script>
/**
 * Компонент отображает список интервалов самовывоза
 * @module PageShop/Component/Intervals
 * @requires vuex
 * @requires Shared/Interval
 */
import { createNamespacedHelpers } from 'vuex'
import Interval from 'Shared/Interval'

const { mapState, mapMutations } = createNamespacedHelpers('storeModule/pickupModule')

export default {
  name: 'Intervals',
  components: {
    Interval
  },
  computed: {
    ...mapState(['pickup'])
  },
  methods: {
    ...mapMutations(['updateInterval', 'updateDay', 'removeInterval'])
  }
}
</script>

<style lang="scss" scoped>
.intervals {
  margin: 0 auto;
  padding-bottom: 10px;
  overflow-x: auto;

  .interval {
    width: fit-content;
  }
}
</style>
